import { render, staticRenderFns } from "./DormUserMessages.vue?vue&type=template&id=3af42a85&"
import script from "./DormUserMessages.vue?vue&type=script&lang=js&"
export * from "./DormUserMessages.vue?vue&type=script&lang=js&"
import style0 from "./DormUserMessages.vue?vue&type=style&index=0&id=3af42a85&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports